import React from 'react';
import { FileTextIcon, HomeIcon, BuildingIcon, ScaleIcon, ShieldCheckIcon, GavelIcon, LockIcon, BrainCircuitIcon, AlertTriangleIcon, ClipboardCheckIcon, SearchIcon, GraduationCapIcon, NetworkIcon } from 'lucide-react';
const practices = [{
  title: 'Contract Law & Legal Advisory',
  description: 'Drafting, reviewing, and negotiating commercial contracts and providing ongoing legal advisory.',
  icon: FileTextIcon
}, {
  title: 'Conveyancing & Property',
  description: 'End-to-end legal support in land and property transactions, including due diligence and registration.',
  icon: HomeIcon
}, {
  title: 'Company Structuring',
  description: 'Market entry support, business setup, structure advisory, and governance framework development.',
  icon: BuildingIcon
}, {
  title: 'Mediation Services',
  description: 'Facilitation of Alternative Dispute Resolution through structured and impartial mediation.',
  icon: ScaleIcon
}, {
  title: 'Commissioner for Oaths',
  description: 'Administering oaths, witnessing signatures, and notarization of legal documents.',
  icon: ShieldCheckIcon
}, {
  title: 'Litigation',
  description: 'Civil Litigation, Employment and Labour Disputes, Family and Succession matters.',
  icon: GavelIcon
}, {
  title: 'Data Privacy & Protection',
  description: 'ODPC registration, privacy policies, DPIAs, and comprehensive data protection compliance.',
  icon: LockIcon
}, {
  title: 'AI Governance and Ethics',
  description: 'Drafting AI governance frameworks, ethical policies, and ensuring regulatory compliance.',
  icon: BrainCircuitIcon
}, {
  title: 'Financial Crime & AML-CFT',
  description: 'Risk assessments, policy development, mock inspections, and advisory on AML-CFT-CPF.',
  icon: AlertTriangleIcon
}, {
  title: 'Legal & Compliance Audits',
  description: 'Comprehensive legal and regulatory audits, obligations registers, and FATCA/CRS support.',
  icon: ClipboardCheckIcon
}, {
  title: 'Due Diligence',
  description: 'In-depth background checks evaluating potential partners, IT security, and financial stability.',
  icon: SearchIcon
}, {
  title: 'Trainings',
  description: 'Customized training for boards, executives, and staff on key compliance areas and risk management.',
  icon: GraduationCapIcon
}, {
  title: 'Third-Party Risk Management',
  description: 'Developing policies pertaining to procurement, contractual risks, and auditing rights.',
  icon: NetworkIcon
}];
export function PracticeAreas() {
  return <section id="practice-areas" className="py-32 lg:py-40 bg-navy relative border-y border-[#D4AF37]/20" data-id="element-185">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-186" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-187">
        <div className="mb-24 max-w-3xl" data-id="element-188">
          <div className="flex items-center space-x-4 mb-6" data-id="element-189">
            <div className="h-px w-8 bg-[#D4AF37]" data-id="element-190"></div>
            <h2 className="text-xs font-cormorant font-bold tracking-[0.3em] text-[#D4AF37] uppercase" data-id="element-191">
              Expertise
            </h2>
          </div>
          <h3 className="font-playfair text-4xl md:text-6xl font-bold text-white tracking-tight mb-8" data-id="element-192">
            Practice Areas
          </h3>
          <p className="font-cormorant text-2xl text-blue-100 font-light leading-relaxed italic" data-id="element-193">
            We provide comprehensive legal solutions tailored to meet the
            dynamic needs of modern businesses and individuals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16" data-id="element-194">
          {practices.map((practice, index) => {
          const Icon = practice.icon;
          return <div key={index} className="group flex flex-col items-start relative p-8 border border-white/5 hover:border-[#D4AF37]/30 transition-colors duration-500 bg-white/[0.02] hover:bg-white/[0.04]" data-id="element-195">
                {/* Gold corner accent on hover */}
                <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-196" />

                <div className="w-14 h-14 bg-navy border border-[#D4AF37]/50 flex items-center justify-center mb-8 group-hover:bg-[#D4AF37] transition-colors duration-500 shadow-[0_0_15px_rgba(212,175,55,0.1)] group-hover:shadow-[0_0_20px_rgba(212,175,55,0.4)]" data-id="element-197">
                  <Icon className="h-6 w-6 text-[#D4AF37] group-hover:text-navy transition-colors duration-500" strokeWidth={1.5} data-id="element-198" />
                </div>
                <h4 className="font-playfair text-2xl font-bold text-white mb-4 tracking-tight group-hover:text-[#D4AF37] transition-colors duration-500" data-id="element-199">
                  {practice.title}
                </h4>
                <p className="text-blue-100/70 font-light leading-relaxed" data-id="element-200">
                  {practice.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}